import { render, staticRenderFns } from "./TemplteEmailAdd.vue?vue&type=template&id=cb71f2c6&scoped=true&"
import script from "./TemplteEmailAdd.vue?vue&type=script&lang=js&"
export * from "./TemplteEmailAdd.vue?vue&type=script&lang=js&"
import style0 from "./TemplteEmailAdd.vue?vue&type=style&index=0&id=cb71f2c6&prod&scoped=true&lang=css&"
import style1 from "./TemplteEmailAdd.vue?vue&type=style&index=1&id=cb71f2c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb71f2c6",
  null
  
)

export default component.exports